import z from 'zod'

export enum ReportElementType {
  WIDGET = 'widget',
  TEXT = 'text',
  SVG = 'svg',
  TEST = 'test',
  NONE = 'none',
  IMAGE = 'image',
  ADMIN_LOGO = 'admin-logo',
  USER_COMPANY_LOGO = 'user-company-logo',
}

export enum ReportSlideOrientation {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
}

export type ReportElementProps = {
  [key: string]: any
}

export type ReportElement = {
  id: string
  type: ReportElementType
  x: number
  y: number
  width: number
  height: number
  angle: number
  zIndex: number
  props: ReportElementProps
  linked?: string
}

export type ReportElementList = Record<string, ReportElement>

export type ReportSlide = {
  id: string
  index: number
  elements: ReportElementList
}

export type ReportSlideList = Record<string, ReportSlide>

export type ReportSettings = {
  pids: string[]
}

export type Report = {
  id: string
  title: string
  img?: string
  base?: boolean
  //TODO(catriel): Move this per slide ????
  orientation: ReportSlideOrientation
  slides: ReportSlideList
  settings: ReportSettings
}

const sharedReportSchema = z.object({
  userId: z.string(),
  reportId: z.string(),
  printId: z.string(),
  status: z.literal('pending').or(z.literal('finished')).or(z.literal('error')),
  dateStarted: z.string(),
  url: z.string().optional(),
})

export type SharedReport = z.infer<typeof sharedReportSchema>
